<template>
  <div class="main pa-4">
    <div class="headline text-center">สรุปผลการประเมินคุณลักษณะ</div>
    <div
      class="display-1 text-center mt-3 primary--text text--darken-2 text-uppercase"
    >
      บริษัท
      {{ $store.state.company.title || '-' }}
    </div>

    <p v-if="defaultForm != null" class="body-1 mt-4">
      {{ defaultForm.formDesc }}
    </p>

    <div class="mt-4">
      <v-row align="stretch">
        <v-col cols="12" lg="5" xl="6">
          <v-card elevation="0" outlined class="fill-height">
            <v-row class="align-center">
              <v-col cols="12" md="6">
                <div style="max-width: 350px" class="mx-auto">
                  <apexchart
                    type="pie"
                    width="100%"
                    :options="chartOptions"
                    :series="series"
                  ></apexchart>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <div
                  :class="{
                    'mr-4': $vuetify.breakpoint.lgOnly,
                    'mr-10': $vuetify.breakpoint.xl,
                  }"
                >
                  <div class="subtitle-1">จำแนกตาม Rank (คน)</div>
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>RISER</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip small dark :color="chartOptions.colors[0]">{{
                          getValueRank('RISER')
                        }}</v-chip>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>SETTLER</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action class="my-0">
                        <v-chip small dark :color="chartOptions.colors[1]">{{
                          getValueRank('SETTLER')
                        }}</v-chip>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>WANDERLUSTER</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip small dark :color="chartOptions.colors[2]">{{
                          getValueRank('WANDERLUSTER')
                        }}</v-chip>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>NEOPHYTE</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip small dark :color="chartOptions.colors[3]">{{
                          getValueRank('NEOPHYTE')
                        }}</v-chip>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="7" xl="6">
          <v-card elevation="0" outlined class="fill-height">
            <v-card-text>
              <p class="body-1 text--primary">
                จากการวิเคราะห์ประเภทบุคลากรของบริษัท จำนวน
                {{
                  overviewData != null && overviewData.rank != null
                    ? overviewData.rank.totalAssessor
                    : 0
                }}
                คน พบว่า มี RISER จำนวน {{ getValueRank('RISER') }} คน คิดเป็น
                {{ getValueRank('RISER', true) }}% Wanderluster จำนวน
                {{ getValueRank('WANDERLUSTER') }} คน คิดเป็น
                {{ getValueRank('WANDERLUSTER', true) }}% Settler จำนวน
                {{ getValueRank('SETTLER') }} คน คิดเป็น
                {{ getValueRank('SETTLER', true) }}% และ Neophyte จำนวน
                {{ getValueRank('NEOPHYTE') }} คนคิดเป็น
                {{ getValueRank('NEOPHYTE', true) }}% โดยมีจำนวนคน
                ที่ต้องการการฝึกอบรม Training Needs ตามหมวดหมู่ดังนี้
              </p>

              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr class="grey lighten-1">
                      <th colspan="5" class="text-center title">
                        TRAINING NEEDS (คน)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="grey lighten-2">
                      <td class="text-center subtitle-1">LEADERSHIP</td>
                      <td class="text-center subtitle-1">TEAMWORK</td>
                      <td class="text-center subtitle-1">
                        GROWTH <br />MINDSET
                      </td>
                      <td class="text-center subtitle-1">CREATIVE</td>
                      <td class="text-center subtitle-1">RESILIENCE</td>
                    </tr>
                    <tr class="white">
                      <td class="text-center">
                        {{ getValueTrainingNeeds('leaderShip') }}
                      </td>
                      <td class="text-center">
                        {{ getValueTrainingNeeds('teamwork') }}
                      </td>
                      <td class="text-center">
                        {{ getValueTrainingNeeds('growthMindset') }}
                      </td>
                      <td class="text-center">
                        {{ getValueTrainingNeeds('creative') }}
                      </td>
                      <td class="text-center">
                        {{ getValueTrainingNeeds('resilence') }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <v-divider class="my-4"></v-divider>
    <div class="headline">ผลการประเมินบุคลากรรายบุคคล</div>
    <div class="toolbar mt-4">
      <v-sheet color="white" class="pa-4" rounded>
        <div class="d-flex align-center">
          <div>
            <v-text-field
              outlined
              hide-details
              placeholder="Search by Name"
              v-model="filter.name"
              @change="fetchUserList"
            ></v-text-field>
          </div>
          <div class="ml-3">
            <v-select
              clearable
              :items="itemsOfRank"
              outlined
              dense
              hide-details
              placeholder="Filter by Rank"
              v-model="filter.rank"
              @change="fetchUserList"
            ></v-select>
          </div>
          <div class="ml-3">
            <v-btn depressed color="grey lighten-2" @click="resetFilter"
              >Clear</v-btn
            >
          </div>
          <div class="flex-grow-1"></div>
          <v-btn
            depressed
            color="info"
            @click="downloadList"
            :loading="downloadProgress"
            >Download</v-btn
          >
        </div>
      </v-sheet>
    </div>
    <div class="users-list mt-4">
      <v-data-table
        dense
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:item.name="{ item }">
          {{ item.userDetail.firstName }} {{ item.userDetail.lastName }}
        </template>
        <template v-slot:item.finishDate="{ value }">
          {{ value | moment('DD/MM/YYYY HH:mm:ss') }}
        </template>
        <template v-slot:item.rank="{ item }">
          <span class="body-2">{{ item.report.myGroup.key }}</span>
        </template>
        <template v-slot:item.userDetail.gender="{ value }">
          <template v-if="value == 'male'"> Male </template>
          <template v-else-if="value == 'female'"> Female </template>
          <template v-else> Unknow </template>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import Vue from 'vue';
import service, { headers, ranks, formKey, groupKeys } from './service';
export default {
  components: {
    apexchart: VueApexCharts,
  },
  data: () => ({
    series: [0, 0, 0, 0],
    chartOptions: {
      colors: ['#4187F4', '#FABE04', '#EB4235', '#36A954'],
      labels: ['RISER', 'SETTLER', 'WANDERLUSTER', 'NEOPHYTE'],
      //   responsive: [
      //     {
      //       breakpoint: 480,
      //       options: {
      //         chart: {
      //           width: 200,
      //         },
      //         legend: {
      //           position: 'bottom',
      //         },
      //       },
      //     },
      //   ],
      plotOptions: {
        pie: {
          dataLabels: {
            offset: -5,
          },
        },
      },
      legend: {
        show: false,
        position: 'left',
        horizontalAlign: 'left',
        itemMargin: {
          vertical: 5,
        },
      },
    },
    totalItems: 0,
    items: [],
    itemsOfRank: ranks,
    headers: headers,
    loading: false,
    options: {},
    defaultForm: null,
    filter: {
      name: null,
      rank: null,
    },
    overviewData: {},
    groupKeys: groupKeys,
    downloadProgress: false,
  }),
  beforeRouteEnter(to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!
    service
      .viewGuard()
      .then((val) => {
        if (val == true) {
          next();
        } else {
          // redirect to default page
          next({
            path: '/',
          });
        }
      })
      .catch((err) => {
        next({
          path: '/',
        });
      });
  },
  watch: {
    options: {
      handler() {
        this.fetchUserList();
      },
      deep: true,
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      service
        .getFormByKey(formKey)
        .then((form) => {
          this.defaultForm = form;

          return service.getOverview();
        })
        .then((data) => {
          if (data != null) {
            this.overviewData = data;
            if (this.overviewData.rank != null) {
              this.series = this.overviewData.rank.ranks.map((x) => x.total);
            }
          } else {
            this.overviewData = null;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getValueTrainingNeeds(key) {
      if (
        this.overviewData != null &&
        this.overviewData.trainingNeeds != null
      ) {
        return this.overviewData.trainingNeeds[key];
      }
      return 0;
    },
    getValueRank(key, asPErcentage = false) {
      if (this.overviewData != null && this.overviewData.rank != null) {
        let obj = this.overviewData.rank.ranks.find((x) => x._id == key);
        if (asPErcentage) {
          return obj.percentage;
        } else {
          return obj.total;
        }
      }
      return 0;
    },
    resetFilter() {
      this.filter = {
        name: null,
        rank: null,
      };
      this.fetchUserList();
    },
    fetchUserList() {
      this.loading = true;
      // const { sortBy, sortDesc, page, itemsPerPage } = this.options
      const filter = { ...this.options, ...this.filter }; // add more paramerters here such as name or gender
      service
        .getListOfUser(filter)
        .then((resp) => {
          if (resp.data != null) {
            this.items = resp.data.data;
            this.totalItems = resp.data.total;
          } else {
            this.items = [];
            this.totalItems = 0;
          }
        })
        .catch((err) => {
          // do nothing
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadList() {
      this.downloadProgress = true;
      service
        .getDownloadLink()
        .then((resp) => {
          var windowUrl = window.URL || window.webkitURL;
          var url = windowUrl.createObjectURL(new Blob([resp.data]));
          var anchor = document.createElement('a');
          let date = Vue.moment().format('YYYY-MM-DD-HH:mm:ss');
          anchor.download = `report-user-list_${date}.xlsx`;
          anchor.href = url;
          document.body.appendChild(anchor);
          anchor.click();
          anchor.remove();
        })
        .catch((err) => {})
        .finally(() => {
          this.downloadProgress = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$borderStyle: 1px solid #c9c9c9 !important;
table th + th {
  border-left: $borderStyle;
}
table td + td {
  border-left: $borderStyle;
}
table td {
  &:first-child {
    border-left: $borderStyle;
  }
  &:last-child {
    border-right: 1px solid #c9c9c9 !important;
  }
}
table tr:last-child td {
  border-bottom: $borderStyle;
}
</style>